module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "social-signup-container"
  }, [_c('div', {
    staticClass: "sign-btn",
    on: {
      "click": function($event) {
        _vm.wechatHandleClick('wechat')
      }
    }
  }, [_c('span', {
    staticClass: "wx-svg-container"
  }, [_c('wscn-icon-svg', {
    staticClass: "icon",
    attrs: {
      "icon-class": "weixin"
    }
  })], 1), _vm._v("\n        微信\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "sign-btn",
    on: {
      "click": function($event) {
        _vm.tencentHandleClick('tencent')
      }
    }
  }, [_c('span', {
    staticClass: "qq-svg-container"
  }, [_c('wscn-icon-svg', {
    staticClass: "icon",
    attrs: {
      "icon-class": "QQ"
    }
  })], 1), _vm._v("\n        QQ\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-323a68b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/login/socialsignin.vue
// module id = 268
// module chunks = 30